import { isArray } from '@cloud-sn/v-utils';
import Selector from '../selector';
import SearchInput from '../searchInput';
export default {
  methods: {
    renderSingleTrigger: function renderSingleTrigger() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          getSelectionValue = this.getSelectionValue,
          placeholder = this.placeholder;
      var triggerNode = null;
      var selectionValue = getSelectionValue();

      if (isArray(selectionValue) && selectionValue.length > 0) {
        var _selectionValue$ = selectionValue[0],
            label = _selectionValue$.label,
            value = _selectionValue$.value;
        triggerNode = h("span", {
          "class": "".concat(prefixCls, "-selection-selected-value")
        }, [label || value]);
      } else {
        triggerNode = h("span", {
          "class": "".concat(prefixCls, "-selection__placeholder")
        }, [placeholder]);
      }

      return h(Selector, {
        "slot": "trigger",
        "attrs": {
          "show-arrow": true,
          "selections": selectionValue
        }
      }, [h("div", {
        "class": "".concat(prefixCls, "-selection__rendered")
      }, [triggerNode])]);
    },
    renderSinglePopup: function renderSinglePopup() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          showSearch = this.showSearch;
      return showSearch ? h("div", {
        "class": "".concat(prefixCls, "-dropdown-search")
      }, [h(SearchInput)]) : null;
    }
  }
};